import React from "react";
import PropTypes from "prop-types";

const Block = ({
  step,
  headline,
  description,
  children,
  inactive,
  visible,
  required
}) => {
  if (!visible) return false;

  return (
    <section
      className={`builder__block${inactive ? " is-inactive" : ""}${
        step ? " has-step" : ""
      }`}
    >
      {headline && (
        <div className="builder__block-head">
          {step && <div className="builder__block-step">{step}</div>}
          <div className="builder__block-text">
            <div className="builder__block-headline">
              {headline}
              {required ? <sup>*</sup> : ""}
            </div>
            {description && (
              <div className="builder__block-description">{description}</div>
            )}
          </div>
        </div>
      )}
      <div className="builder__block-body">{children}</div>
    </section>
  );
};

Block.propTypes = {
  step: PropTypes.number,
  headline: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  inactive: PropTypes.bool,
  visible: PropTypes.bool,
  required: PropTypes.bool
};

Block.defaultProps = {
  step: null,
  headline: null,
  description: null,
  inactive: false,
  visible: true,
  required: false
};

export default Block;
